<section>
    <h2 class="header">{{pageData.header}}</h2>
    <p *ngIf="addonLines.length === 0" class="no-eligible-plan">{{ pageData.noEligiblePlan }}</p>
    <p *ngIf="addonLines.length !== 0 && isResiInternationalEligibilityChanges" class="subheader">{{ pageData.subHeader }}</p>
    <form *ngIf="addonLines.length > 0" [formGroup]="passForm">
        <div formArrayName="checkboxes">
            <div class="pass-card-container">
                <div class="card" *ngFor="let option of passOptions; let i = index">
                    <div class="name-icon" [style.backgroundColor]="option.color"><span data-notranslate>{{ option.iconLetter }}</span>
                    </div>
                    <div class="pass-content">
                        <p class="name" data-notranslate>{{ option.displayName }}</p>
                        <p class="line-status">{{ option.lineNumber | phone }}</p>
                    </div>

                    <div *ngIf="!(isResiInternationalEligibilityChanges && !option.isEditable && option.status !== 'INCLUDED' && option.status !== 'PENDING_REMOVAL')" class="checkbox-container">
                        <input type="checkbox" [id]="'pass-checkbox-' + i" [value]="option.status" [checked]="option.isSelected" role="checkbox"
                            xmAriaCheckbox [isInputChecked]="option.isSelected" [attr.aria-label]="pageData.checkboxLabel + ' - ' + option.displayName + ' (' + option.lineNumber + ')'"
                            (change)="onPassSelectionChange(option, $event)" [disabled]="!option.isEditable" />
                        <div class="checkbox-label">
                            <label [for]="'pass-checkbox-' + i">{{ pageData.checkboxLabel }}</label>
                            <span *ngIf="option.status === 'INCLUDED'">{{AddonPassStatus.INCLUDED}}</span>
                            <span *ngIf="option.status === 'PENDING_REMOVAL'">{{AddonPassStatus.PENDING_REMOVAL}}</span>
                            <span *ngIf="option.status === 'ACTIVE'">{{AddonPassStatus.ACTIVE}}</span>
                            <span *ngIf="option.status === 'INACTIVE'">{{pageData.price}}</span>
                        </div>
                    </div>
                    <span class="note" *ngIf="((isResiInternationalEligibilityChanges) ? pageData.internationalEligibilityCheckboxNote : pageData.checkboxNote) && option.status === 'INCLUDED'">
                        {{ (isResiInternationalEligibilityChanges) ? pageData.internationalEligibilityCheckboxNote : pageData.checkboxNote }}</span>
                    <span class="note" *ngIf="(isResiInternationalEligibilityChanges && !option.isEditable && option.status !== 'INCLUDED' && option.status !== 'PENDING_REMOVAL')">{{ pageData.inEligibleNote }}</span>
                </div>
            </div>
        </div>
    </form>
</section>
